export type MelonCategory = {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  icon: string;
};

export type MelonItem = {
  title: string;
  summary: string;
  category: string;
  status: "确认瓜" | "落地瓜" | "盖棺定论";
  time: string;
  source: string;
  hot: string;
};

export type TimelineEvent = {
  date: string;
  title: string;
  note: string;
  tag: string;
};

export type FaqItem = {
  q: string;
  a: string;
};

export const categories: MelonCategory[] = [
  { id: "movie", name: "影视综艺", en: "SHOWS", desc: "选角、换角、档期与节目现场争议的追踪与定论整理", count: "今日 6 条", icon: "ri-clapperboard-line" },
  { id: "star", name: "明星动态", en: "STARS", desc: "艺人工作室声明、商务与合作变动的已核实信息", count: "今日 5 条", icon: "ri-user-star-line" },
  { id: "live", name: "直播网红", en: "LIVE", desc: "直播间话术、价格与售后争议的多方求证结论", count: "今日 4 条", icon: "ri-live-line" },
  { id: "sport", name: "体坛内幕", en: "SPORTS", desc: "引援、转档与赛事安排等被官方坐实的消息", count: "今日 3 条", icon: "ri-run-line" },
  { id: "business", name: "商界瓜田", en: "BUSINESS", desc: "品牌、门店与加盟相关的公开回应汇总", count: "今日 3 条", icon: "ri-briefcase-4-line" },
  { id: "music", name: "音乐圈", en: "MUSIC", desc: "巡演、专辑与演出安排的官方确认信息", count: "今日 2 条", icon: "ri-mic-2-line" },
];

export const todayMelons: MelonItem[] = [
  { title: "某选秀节目导师阵容调整，节目组口径终获一致", summary: "自官宣延期后线索较为分散，近期制片方与售票平台先后发布公开说明，关于导师出场的多处信息已相互印证，争论焦点已基本清晰。", category: "影视综艺", status: "确认瓜", time: "10:40", source: "节目组公开说明", hot: "9.2k" },
  { title: "某演员工作室回应合约变动，双方联合声明落地", summary: "围绕合作期限的不同说法持续了一天，两位相关方最终共同发声，对时间线与补偿安排给出统一版本，分歧随之收窄。", category: "明星动态", status: "落地瓜", time: "09:15", source: "双方联合声明", hot: "12.6k" },
  { title: "头部直播间「最低价」争议，以公开补差价收场", summary: "针对同款商品不同渠道价差的质疑，直播间运营方当日发布处理方案，并公示核查过程，价格口径趋于一致。", category: "直播网红", status: "落地瓜", time: "08:50", source: "运营方公告", hot: "8.9k" },
  { title: "某剧组换角传闻获制片方正面答复", summary: "选角变动的消息发酵后，制片方接受媒体采访作出回应，说明调整仅涉及个别临时角色，主要阵容维持不变。", category: "影视综艺", status: "确认瓜", time: "11:05", source: "制片方采访", hot: "7.1k" },
  { title: "某歌手巡演加场，售票平台页面同步坐实", summary: "加场信息此前仅见于零散渠道，官方票务页面更新场次安排后，观众与渠道信息完成核对，网传范围得到圈定。", category: "音乐圈", status: "盖棺定论", time: "昨天 22:30", source: "票务平台页面", hot: "10.2k" },
  { title: "某俱乐部引援传闻经官宣消息源坐实", summary: "围绕球员去向的多种说法里，俱乐部官方渠道给出最终名单，此前流传的若干版本随之被排除，结论趋于单一。", category: "体坛内幕", status: "盖棺定论", time: "昨天 21:00", source: "俱乐部官宣", hot: "6.4k" },
  { title: "某连锁品牌门店调整，总部回应明确范围", summary: "关于门店闭改的讨论热度上升后，品牌总部发布说明，列出调整门店的具体名单，其余门店经营不受影响。", category: "商界瓜田", status: "确认瓜", time: "昨天 19:40", source: "品牌总部说明", hot: "5.3k" },
  { title: "综艺嘉宾花絮片段被剪辑方完整还原", summary: "一段节选画面引发对嘉宾言行的误读，节目组放出原始素材并加注说明，还原了语境，讨论方向随之回归内容本身。", category: "影视综艺", status: "落地瓜", time: "昨天 18:20", source: "节目组原素材", hot: "11.4k" },
];

export const listMelons: MelonItem[] = [
  { title: "某女星综艺定位争议：节目组与本人先后回应", summary: "围绕镜头占比与角色分工的讨论，节目组发布分工说明，艺人团队随后转达态度，两方口径已对齐。", category: "影视综艺", status: "落地瓜", time: "本周", source: "节目组+团队说明", hot: "13.1k" },
  { title: "某演员告别角色声明获多方呼应", summary: "角色与演员解绑的消息传出后，其本人发声致意，制片方转发确认，相关讨论随之由猜测转为总结。", category: "明星动态", status: "盖棺定论", time: "本周", source: "本人+制片方", hot: "9.8k" },
  { title: "某直播抽奖规则被指含糊，平台介入复核", summary: "对中奖规则的质疑集中后，平台方介入并公开复核过程，主播同步更新规则说明，存疑点得到解释。", category: "直播网红", status: "落地瓜", time: "本周", source: "平台复核公告", hot: "7.7k" },
  { title: "某球队主帅去向，官方发布会一锤定音", summary: "关于教练组是否续任的多种传闻，官方发布会对下赛季安排给出明确表态，传闻随之结束。", category: "体坛内幕", status: "盖棺定论", time: "本周", source: "官方发布会", hot: "6.2k" },
  { title: "某品牌联名档期调整获双方确认", summary: "联名发售时间被延后的消息，经品牌方与合作方共同确认，新档期与补偿说明均已公示。", category: "商界瓜田", status: "确认瓜", time: "本周", source: "品牌方公告", hot: "5.1k" },
  { title: "某专辑曲目顺序争议，制作人正面回应", summary: "对曲序编排的猜测较多，制作人受访给出创作说明，解释了顺序逻辑，讨论转向音乐本身。", category: "音乐圈", status: "落地瓜", time: "本周", source: "制作人采访", hot: "4.6k" },
];

export const hotRanking: MelonItem[] = [
  { title: "头部直播间「最低价」补差价方案落地", summary: "处理方案与核查过程均已公示，价格口径趋于一致。", category: "直播网红", status: "落地瓜", time: "热", source: "运营方公告", hot: "12.6k" },
  { title: "某演员合约变动，联合声明达成统一版本", summary: "双方对时间线给出一致说法，分歧收窄。", category: "明星动态", status: "落地瓜", time: "热", source: "联合声明", hot: "12.6k" },
  { title: "综艺嘉宾片段被完整还原，误读得到澄清", summary: "原素材与加注说明公开，讨论回归内容。", category: "影视综艺", status: "落地瓜", time: "热", source: "原素材", hot: "11.4k" },
  { title: "某歌手巡演加场，票务页面同步坐实", summary: "官方页面更新后，网传范围得到圈定。", category: "音乐圈", status: "盖棺定论", time: "热", source: "票务页面", hot: "10.2k" },
  { title: "某女星定位争议，两方口径对齐", summary: "分工说明与本人态度均已转达。", category: "明星动态", status: "落地瓜", time: "热", source: "节目组+团队", hot: "9.8k" },
  { title: "某选秀导师阵容调整获证实", summary: "制片方与票务平台信息相互印证。", category: "影视综艺", status: "确认瓜", time: "热", source: "公开说明", hot: "9.2k" },
  { title: "某头部主播抽奖规则完成复核", summary: "平台公示复核过程，规则更新。", category: "直播网红", status: "落地瓜", time: "热", source: "平台公告", hot: "7.7k" },
  { title: "某剧组换角传闻获正面答复", summary: "制片方说明仅涉临时角色。", category: "影视综艺", status: "确认瓜", time: "热", source: "制片方采访", hot: "7.1k" },
];

export const timeline: TimelineEvent[] = [
  { date: "09.05", title: "某音乐节目换档传闻收束", note: "官方票务与节目组口径一致，档期安排固定，结论进入盖棺阶段。", tag: "盖棺定论" },
  { date: "09.04", title: "某演员合作变动的联合声明发出", note: "双方同日发声，时间线与补偿统一，落地瓜确认。", tag: "落地瓜" },
  { date: "09.03", title: "某直播间价格争议公示核查", note: "运营方公开处理方案，价格口径趋于一致。", tag: "落地瓜" },
  { date: "09.02", title: "某球队主帅留任获得官方表态", note: "发布会明确答复，相关传闻结束，落地瓜坐实。", tag: "盖棺定论" },
  { date: "09.01", title: "某综艺分工说明发布", note: "节目组说明镜头分工，艺人团队转达态度，初步有定论。", tag: "确认瓜" },
  { date: "08.30", title: "某巡演加场信息完成多方核对", note: "售票平台页面与官方口径一致，网传范围得到圈定。", tag: "盖棺定论" },
];

export const faqs: FaqItem[] = [
  { q: "「吃瓜今天」的实锤是怎么认定的？", a: "我们不会把单条爆料直接当成实锤。收录前会至少交叉核对公开说明、官方口径与多方信源，当多处关键信息能够相互印证时，才标注为已实锤；仍存疑的内容会归入「待跟进」而非实锤名单。" },
  { q: "「确认瓜、落地瓜、盖棺定论」有什么区别？", a: "三者代表不同定论程度：确认瓜指关键信息已有公开回应并基本对齐；落地瓜指相关方给出可查证的处理或声明，事态收尾；盖棺定论指多方信息完全一致，争议焦点已不再需要猜测。" },
  { q: "辟谣和反转会被更新吗？", a: "会。吃瓜动态常会反转，因此我们会在核实新信息后及时更新原条目状态并标注更新时间，避免让你停留在过时结论上。看到「已更新」标记时，以最新状态为准。" },
  { q: "为什么有的内容用了「某」「相关方」的表述？", a: "为避免标题党式点名与断章取义，我们会优先使用可验证的客观描述，对尚未形成共识的个体不作标签式定性，这也是「先核实后收录」原则的一部分。" },
  { q: "更新频率是怎样的？", a: "栏目在工作日每日更新，通常在早间集中收录前一日热度较高、且已有明确结论的话题，周末会整理「一周落地瓜」做阶段总结。" },
  { q: "如何确认一条信息是不是被你们收录过？", a: "你可以使用站内搜索或在实锤名单中按栏目筛选。每条收录都带有信源字段，若某条未被收录，通常说明相关信息仍未达到「可交叉印证」的门槛。" },
];

export const siteStats = [
  { value: "26", unit: "条", label: "今日已收录" },
  { value: "58", unit: "条", label: "本周实锤汇总" },
  { value: "12", unit: "条", label: "本周落地瓜" },
  { value: "6", unit: "个", label: "常驻栏目" },
];